import { resolveLogoUrl } from "../config/siteBranding";

if (typeof document !== "undefined") {
  const favicon = process.env.REACT_APP_FAVICON_LOGO?.trim();
  if (favicon && !/^#\{REACT_APP_[^}]+\}#$/.test(favicon)) {
    const link = document.querySelector('link[rel="icon"]');
    if (link) {
      link.href = resolveLogoUrl(favicon);
    }
  }
}
